/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Googlefailed2Inputs */

const id_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In gagal. Silakan coba lagi.`)
};

const ms_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log Masuk Google gagal. Sila cuba lagi.`)
};

const da_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Log Ind mislykkedes. Prøv venligst igen.`)
};

const de_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.`)
};

const en_us2_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In failed. Please try again.`)
};

const es_es2_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error en el inicio de sesión de Google. Por favor, inténtalo de nuevo.`)
};

const es_mx2_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El inicio de sesión con Google falló. Por favor, inténtalo de nuevo.`)
};

const fil_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigo ang Google Sign-In. Pakisubukan muli.`)
};

const fr_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La connexion Google a échoué. Veuillez réessayer.`)
};

const it_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso Google fallito. Riprova.`)
};

const hu_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google bejelentkezés sikertelen. Kérjük, próbáld újra.`)
};

const nl_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google-inloggen mislukt. Probeer het opnieuw.`)
};

const no_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google-pålogging mislyktes. Prøv igjen.`)
};

const pl_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie przez Google nie powiodło się. Spróbuj ponownie.`)
};

const pt_br2_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In failed. Please try again.`)
};

const pt_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O início de sessão com o Google falhou. Tente novamente.`)
};

const ro_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autentificarea Google a eșuat. Încearcă din nou.`)
};

const fi_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google-kirjautuminen epäonnistui. Yritä uudelleen.`)
};

const sv_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google-inloggning misslyckades. Försök igen.`)
};

const vi_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập Google thất bại. Vui lòng thử lại.`)
};

const tr_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Oturum Açma başarısız oldu. Lütfen tekrar deneyin.`)
};

const cs_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení přes Google selhalo. Zkuste to prosím znovu.`)
};

const bg_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Входът с Google не бе успешен. Моля, опитайте отново.`)
};

const ru_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход через Google не удался. Пожалуйста, попробуйте снова.`)
};

const uk_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вхід через Google не вдався. Спробуйте ще раз.`)
};

const ar_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل تسجيل الدخول باستخدام Google. حاول مرة أخرى.`)
};

const hi_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google साइन-इन विफल।`)
};

const th_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การลงชื่อเข้าใช้ด้วย Google ล้มเหลว กรุณาลองอีกครั้ง`)
};

const ja_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google サインインに失敗しました。もう一度お試しください。`)
};

const zh_cn2_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In failed. Please try again.`)
};

const zh_hant1_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In failed. Please try again.`)
};

const ko_forms_androidbeta_googlefailed2 = /** @type {(inputs: Forms_Androidbeta_Googlefailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google Sign-In failed. Please try again.`)
};

/**
* | output |
* | --- |
* | "Google Sign-In failed. Please try again." |
*
* @param {Forms_Androidbeta_Googlefailed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_googlefailed2 = /** @type {((inputs?: Forms_Androidbeta_Googlefailed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Googlefailed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_googlefailed2(inputs)
	if (locale === "ms") return ms_forms_androidbeta_googlefailed2(inputs)
	if (locale === "da") return da_forms_androidbeta_googlefailed2(inputs)
	if (locale === "de") return de_forms_androidbeta_googlefailed2(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_googlefailed2(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_googlefailed2(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_googlefailed2(inputs)
	if (locale === "fil") return fil_forms_androidbeta_googlefailed2(inputs)
	if (locale === "fr") return fr_forms_androidbeta_googlefailed2(inputs)
	if (locale === "it") return it_forms_androidbeta_googlefailed2(inputs)
	if (locale === "hu") return hu_forms_androidbeta_googlefailed2(inputs)
	if (locale === "nl") return nl_forms_androidbeta_googlefailed2(inputs)
	if (locale === "no") return no_forms_androidbeta_googlefailed2(inputs)
	if (locale === "pl") return pl_forms_androidbeta_googlefailed2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_googlefailed2(inputs)
	if (locale === "pt") return pt_forms_androidbeta_googlefailed2(inputs)
	if (locale === "ro") return ro_forms_androidbeta_googlefailed2(inputs)
	if (locale === "fi") return fi_forms_androidbeta_googlefailed2(inputs)
	if (locale === "sv") return sv_forms_androidbeta_googlefailed2(inputs)
	if (locale === "vi") return vi_forms_androidbeta_googlefailed2(inputs)
	if (locale === "tr") return tr_forms_androidbeta_googlefailed2(inputs)
	if (locale === "cs") return cs_forms_androidbeta_googlefailed2(inputs)
	if (locale === "bg") return bg_forms_androidbeta_googlefailed2(inputs)
	if (locale === "ru") return ru_forms_androidbeta_googlefailed2(inputs)
	if (locale === "uk") return uk_forms_androidbeta_googlefailed2(inputs)
	if (locale === "ar") return ar_forms_androidbeta_googlefailed2(inputs)
	if (locale === "hi") return hi_forms_androidbeta_googlefailed2(inputs)
	if (locale === "th") return th_forms_androidbeta_googlefailed2(inputs)
	if (locale === "ja") return ja_forms_androidbeta_googlefailed2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_googlefailed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_googlefailed2(inputs)
	return ko_forms_androidbeta_googlefailed2(inputs)
});
export { forms_androidbeta_googlefailed2 as "forms.androidBeta.googleFailed" }